<template>
  <div class="flex w-full h-full">
    <div class="w-64 border-r border-gray-200">
      <slot name="before-navigation" />
      <div class="px-4 py-5 sm:px-6">
        <nav class="space-y-1" aria-label="Sidebar">
          <a
            v-for="(tab, tabIndex) in tabs"
            :key="tabIndex"
            role="button"
            class="flex items-center px-3 py-2 text-sm font-medium rounded-md select-none"
            :class="[
              currentTab === tabIndex
                ? 'bg-gray-200 text-gray-900'
                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900',
            ]"
            aria-current="page"
            @click="setCurrentTabByIndex(tabIndex)"
          >
            <span class="truncate">
              {{ tab.name }}
            </span>
          </a>
        </nav>
      </div>
    </div>
    <div class="flex-1 p-4 sm:p-6 bg-gray-50 rounded-r-lg overflow-y-auto fancy-scrollbar">
      <slot
        :current-tab="currentTab"
        :set-current-tab-by-index="setCurrentTabByIndex"
        :set-current-tab-by-name="setCurrentTabByName"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tabs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentTab: 0,
    };
  },
  methods: {
    setCurrentTab(index) {
      const previousIndex = this.currentTab;
      this.currentTab = index;
      this.$emit('change', { previous: previousIndex, current: index });
    },
    setCurrentTabByIndex(index) {
      if (index < this.tabs.length) {
        this.setCurrentTab(index);
      }
    },
    setCurrentTabByName(name) {
      const index = this.tabs.findIndex((tab) => tab.name === name);

      if (index >= 0) {
        this.setCurrentTab(index);
      }
    },
  },
};
</script>
